// Platform detection (web only)
export const isWeb = true;
export const isMobile = false;

// User type constants
export const USER_TYPES = {
    PUBLIC_USER: 'publicUser',
    COLLECTION: 'collection',
    HOSPITAL: 'isHospital',
    BDO: 'isBdo'
};

// Platform-based user type restrictions
export const getPlatformUserTypeRestrictions = () => {
    // Web: Only Hospital and BDO can use (temporarily allowing Collection for testing)
    return {
        allowed: [USER_TYPES.HOSPITAL, USER_TYPES.BDO, USER_TYPES.COLLECTION],
        blocked: [USER_TYPES.PUBLIC_USER],
        message: 'Please login via Mobile App. Only Hospital and BDO can use the web platform.'
    };
};

// Check if a user type is allowed on current platform
export const isUserTypeAllowed = (userType) => {
    const restrictions = getPlatformUserTypeRestrictions();
    return restrictions.allowed.includes(userType);
};

// Get user type display names
export const getUserTypeDisplayName = (userType) => {
    const displayNames = {
        [USER_TYPES.PUBLIC_USER]: 'Public User',
        [USER_TYPES.COLLECTION]: 'Collection',
        [USER_TYPES.HOSPITAL]: 'Hospital',
        [USER_TYPES.BDO]: 'Blood Donation Organization'
    };
    return displayNames[userType] || userType;
};

// Get available user types for signup (web)
export const getAvailableUserTypesForSignup = () => {
    // Web: Only Hospital and BDO can signup
    return [
        { value: USER_TYPES.HOSPITAL, label: getUserTypeDisplayName(USER_TYPES.HOSPITAL) },
        { value: USER_TYPES.BDO, label: getUserTypeDisplayName(USER_TYPES.BDO) }
    ];
};